import { render, staticRenderFns } from "./PublicTestimonialCard.vue?vue&type=template&id=11c167f9&"
import script from "./PublicTestimonialCard.vue?vue&type=script&lang=js&"
export * from "./PublicTestimonialCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports